export default {
    loading: "Loading...",
    loaded: "Tap anywhere to continue"
}